import styles from './blog-cta-module.css?url'

export const blogCtaModuleLinks = () => [{ rel: 'stylesheet', href: styles }]

export type BlogCtaVariant =
  | 'light-gray-static'
  | 'light-pink-static'
  | 'deep-pink-animated'

type BlogCtaModuleProps = {
  variant: BlogCtaVariant
}

export const BlogCtaModule = ({ variant }: BlogCtaModuleProps) => {
  return (
    <div
      className={`blog-cta-module blog-cta-module--${variant}`}
      data-variant={variant}
    >
      <p className="blog-cta-module__text body-l">
        We love tackling problems like this at Omni. If you're interested in
        building with us, we'd love to speak with you.
      </p>

      <div className="blog-cta-module__actions">
        <a
          className="omni-button blog-cta-module__button blog-cta-module__button--secondary"
          href="https://docs.omni.co/demos"
          rel="noopener"
          target="_blank"
        >
          See the latest
        </a>

        <a
          className="omni-button blog-cta-module__button blog-cta-module__button--primary"
          href="https://jobs.ashbyhq.com/omni"
          rel="noopener"
          target="_blank"
        >
          Join our team
        </a>
      </div>
    </div>
  )
}
